import classNames from 'classnames';
import React from 'react';

import {GridType} from 'constants/SampleConstants';
import {formatGridCoordinates, formatGridNumber} from 'samples/SampleUtil';

export default function GridPosition({
  rowIndex,
  columnIndex,
  gridType,
  gridWidth,
}: {
  rowIndex: number;
  columnIndex: number;
  gridType: GridType;
  gridWidth: number;
}): JSX.Element {
  const coordinates = formatGridCoordinates(rowIndex, columnIndex);
  const number = formatGridNumber(rowIndex, columnIndex, gridWidth);
  return (
    <span>
      {gridType === GridType.BOX && <span className="u-small-spacing-right">{number}</span>}
      <span className={classNames({'u-faded': gridType === GridType.BOX})}>{coordinates}</span>
    </span>
  );
}
